import React, { Component } from 'react';
import { Container, Card, CardBody, Row, Col, Button } from "reactstrap";
import { Link } from "react-router-dom";

import SweetAlert from "react-bootstrap-sweetalert";

import { BaseUrl } from "../../../helpers/Baseurl"
//Import Breadcrumb
import Breadcrumbs from '../../../components/Common/Breadcrumb';

import BootstrapTable from "react-bootstrap-table-next";
import cellEditFactory from "react-bootstrap-table2-editor";

var include_id = 1
var exclude_id = 1

class Details extends Component {
    constructor(props) {
        super(props);
        this.state = {
            includes:[],
            excludes:[],          
        }
    }

    async componentDidMount() {
 
        await this.loadInclusitionData()
        await this.loadExclusitionData()
     }

    
    async loadInclusitionData(){
        let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            };
        await fetch(`${BaseUrl}/api/cms/inclusitions/?category=${id}`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    
                    this.setState({ includes: data })
                        },
                    
                (error) => {
                    console.log(error, 'error------') 
                }
            )  
    }

    async loadExclusitionData(){
        let id = this.props.match.params.id
        const requestOptions = {
            method: 'GET',
            headers: { 'Content-Type': 'application/json' },
            };
        await fetch(`${BaseUrl}/api/cms/exclusitions/?category=${id}`,requestOptions)
            .then(res => res.json())
            .then(
                (data) => {
                    this.setState({ excludes: data }) },
                    
                (error) => {
                    console.log(error, 'error------') 
                }
            ) 
        
    }

    handleAddIncludeRow(){
        const {includes} = this.state
        let newData = includes
        let newRow = {"id": `inc-${include_id}`, "point":""}
        newData.push(newRow)
        include_id = include_id+1
        this.setState({includes:newData})


    }

    handleAddExcludeRow(){
        const {excludes} = this.state
        let newData = excludes
        let newRow = {"id": `exc-${exclude_id}`, "point":""}
        newData.push(newRow)
        exclude_id = exclude_id+1
        this.setState({excludes:newData})
        
    }

    handleDeleteIncludeRow(id){
        let new_id = ""+id
        const strFirstThree = new_id.substring(0,3)
        if (strFirstThree === "inc"){
            let new_data = []
            for (let i=0; i<this.state.includes.length;i++){
                if(this.state.includes[i].id !== id){
                    new_data.push(this.state.includes[i])
                }
            }
            
            this.setState({
                includes:new_data,
                activity_id:"",
                success_confirm: true,
                alert_confirm : false,
                dynamic_title: "Deleted!",
                dynamic_description: "Row has been deleted."
                })

        }
        else {
            const requestOptions = {
                method: 'DELETE',
            };
            fetch(`${BaseUrl}/api/cms/inclusitions/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                        console.log("error")
                    }
                    else{
                        this.loadInclusitionData()
                        this.setState({
                            activity_id:"",
                            success_confirm: true,
                            alert_confirm : false,
                            dynamic_title: "Deleted!",
                            dynamic_description: "Row has been deleted."
                        })
                    }
                }
            )
        }

    }

    handleDeleteExcludeRow(id){
        let new_id = ""+id
        const strFirstThree = new_id.substring(0,3)
        if (strFirstThree === "exc"){
            let new_data = []
            for (let i=0; i<this.state.excludes.length;i++){
                if(this.state.excludes[i].id !== id){
                    new_data.push(this.state.excludes[i])
                }
            }
            
            this.setState({
                excludes:new_data,
                activity_id:"",
                exclude_success_confirm: true,
                exclude_alert_confirm : false,
                dynamic_title: "Deleted!",
                dynamic_description: "Row has been deleted."
                })

        }else {
            const requestOptions = {
                method: 'DELETE',
            };
            fetch(`${BaseUrl}/api/cms/exclusitions/${id}/`,requestOptions)
                .then(res => 
                    {if(res.status >= 400){
                        console.log("error")
                    }
                    else{
                        this.loadExclusitionData()
                        this.setState({
                            activity_id:"",
                            exclude_success_confirm: true,
                            exclude_alert_confirm : false,
                            dynamic_title: "Deleted!",
                            dynamic_description: "Row has been deleted."
                        })
                    }
                }
            )
        }

    }

    handleSaveInclusition = row => {
        let category_id = this.props.match.params.id
        let new_id = ""+row.id
        const strFirstThree = new_id.substring(0,3)
        let includeData = {"point": row.point, "category": category_id}
        if (strFirstThree === "inc"){
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(includeData)
                };
                fetch(`${BaseUrl}/api/cms/inclusitions/`,requestOptions)
                      .then(res => 
                          {if(res.status >= 400){
                            this.loadInclusitionData()
                              
                          }
                          else{
                            this.loadInclusitionData()  
                          }    
                      }
                  )

        }else{
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(includeData)
                };
                fetch(`${BaseUrl}/api/cms/inclusitions/${row.id}/`,requestOptions)
                      .then(res => 
                          {if(res.status >= 400){
                            this.loadInclusitionData()
                              
                          }
                          else{
                            this.loadInclusitionData()  
                          }    
                      }
                  )

        }
    }

    handleSaveExclusition = row => {
        let category_id = this.props.match.params.id
        let new_id = ""+row.id
        const strFirstThree = new_id.substring(0,3)
        let includeData = {"point": row.point, "category": category_id}
        if (strFirstThree === "exc"){
            const requestOptions = {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(includeData)
                };
                fetch(`${BaseUrl}/api/cms/exclusitions/`,requestOptions)
                      .then(res => 
                          {if(res.status >= 400){
                            this.loadExclusitionData()
                              
                          }
                          else{
                            this.loadExclusitionData()  
                          }    
                      }
                  )

        }else{
            const requestOptions = {
                method: 'PUT',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(includeData)
                };
                fetch(`${BaseUrl}/api/cms/exclusitions/${row.id}/`,requestOptions)
                      .then(res => 
                          {if(res.status >= 400){
                            this.loadExclusitionData()
                              
                          }
                          else{
                            this.loadExclusitionData()  
                          }    
                      }
                  )

        }
    }

    

    render() {
        let breadcrumbItems = [
            { title : "Inclusitions & Exclusitions", link : "/inclusitions-exclusitions" },
            { title : `${this.props.match.params.name} Inclusitions & Exclusitions`, link : "#" },
        ]

        const PackegeIncludes = [
            {
                dataField: "id",
                text: "id",
                hidden: true,
            },
            
            {
                dataField: "point",
                text: "Points",
                headerStyle: { backgroundColor: '#fcb92c', width: '90%' },
            },
            
            {
                dataField: "menu",
                isDummyField: true,
                text: "Action",
                editable: false,
                headerStyle: { backgroundColor: '#fcb92c' },
                formatter: (cellContent, row, col) => 
                { 
                    return (
                        <React.Fragment>
                            <Link to="#" onClick={() => this.setState({ activity_id: row.id, alert_confirm:true  })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>                    
                        </React.Fragment>
                      )
          
                }
              },
            ]
            const PackegeExcludes = [
                {
                    dataField: "id",
                    text: "id",
                    hidden: true,
                },
                
                {
                    dataField: "point",
                    text: "Points",
                    headerStyle: { backgroundColor: '#fcb92c', width: '90%' },
                },
                
                {
                    dataField: "menu",
                    isDummyField: true,
                    text: "Action",
                    editable: false,
                    headerStyle: { backgroundColor: '#fcb92c' },
                    formatter: (cellContent, row) => 
                    { 
                        return (
                            <React.Fragment>
                                <Link to="#" onClick={() => this.setState({ activity_id: row.id, exclude_alert_confirm:true  })} className="text-danger"><i className="mdi mdi-trash-can font-size-18"></i></Link>                    
                            </React.Fragment>
                          )
              
                    }
                  },
                ]
        

        
        return (
            <React.Fragment>
        <div className="page-content">
          <Container fluid>

          <Breadcrumbs title={`${this.props.match.params.name} Inclusitions & Exclusitions`} breadcrumbItems={breadcrumbItems} />
          

            <Row>
              <Col xs={6}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">{"Inclusitions"} </h4>
                    <BootstrapTable
                                    keyField="id"
                                    data={this.state.includes}
                                    columns={PackegeIncludes}
                                    cellEdit={ cellEditFactory({    mode: 'dbclick',
                                                                    blurToSave: true,
                                                                    afterSaveCell: (oldValue, newValue, row, column) => { this.handleSaveInclusition(row) }
                                                                }) }
                                />
                    
                    <div style={{textAlign: "center"}}>
                        <Button color="secondary" outline className="waves-effect me-1 mb-3 "  onClick={() => this.handleAddIncludeRow()}>
                            Add Inclusition
                        </Button>
                    </div>

                  </CardBody>
                </Card>
              </Col>
              <Col xs={6}>
                <Card>
                  <CardBody>
                    <h4 className="card-title">{"Exclusitions"} </h4>
                    <BootstrapTable
                                    keyField="id"
                                    data={this.state.excludes}
                                    columns={PackegeExcludes}
                                    cellEdit={ cellEditFactory({    mode: 'dbclick',
                                                                    blurToSave: true,
                                                                    afterSaveCell: (oldValue, newValue, row, column) => { this.handleSaveExclusition(row) }
                                                                }) }
                                />
                    
                    <div style={{textAlign: "center"}}>
                        <Button color="secondary" outline className="waves-effect me-1 mb-3 "  onClick={() => this.handleAddExcludeRow()}>
                            Add Exclusition
                        </Button>
                    </div>

                  </CardBody>
                </Card>
              </Col>
            </Row>
         
          </Container>
        </div>
        {this.state.alert_confirm ? (
                    <SweetAlert
                    title="Are you sure?"
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => this.handleDeleteIncludeRow(this.state.activity_id)}
                    onCancel={() =>
                        this.setState({
                            alert_confirm: false,
                            activity_id:"",

                        })
                    }
                    >
                    You won't be able to revert this!
                    </SweetAlert>
                    ) : null}

                    {this.state.success_confirm ? (
                    <SweetAlert
                    success
                    title={this.state.dynamic_title}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => this.setState({ success_confirm: false, alert_confirm : false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                    ) : null
              }
        {this.state.exclude_alert_confirm ? (
                    <SweetAlert
                    title="Are you sure?"
                    warning
                    showCancel
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => this.handleDeleteExcludeRow(this.state.activity_id)}
                    onCancel={() =>
                        this.setState({
                            exclude_alert_confirm: false,
                            activity_id:"",

                        })
                    }
                    >
                    You won't be able to revert this!
                    </SweetAlert>
                    ) : null}

                    {this.state.exclude_success_confirm ? (
                    <SweetAlert
                    success
                    title={this.state.dynamic_title}
                    confirmBtnBsStyle="success"
                    cancelBtnBsStyle="danger"
                    onConfirm={() => this.setState({ exclude_success_confirm: false, exclude_alert_confirm : false })}
                    >
                        {this.state.dynamic_description}
                    </SweetAlert>
                    ) : null
              }
      </React.Fragment>
        );
    }
}

export default Details;
